import { useState, useEffect, useRef } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Controls from "../../components/FormsUI";
import { useAuth } from "../../utility/auth";
import ImagePreview from "../../components/FormsUI/PreviewImage/index";
import DepartmentController from "../../controller/DepartmentController";
import SubDepartmentController from "../../controller/SubDepartmentController";
import CustomizedSnackbars from "../../components/Alert";
import EditIcon from "@mui/icons-material/Edit";
import Load from "../../components/FormsUI/Loader/index";//../components/FormsUI/Loader/index
import DeleteIcon from "@mui/icons-material/Delete";
import "../../css/style.css";
import { tokens } from "../../theme";
import {
    Container,
    Grid,
    useTheme,
    Box,
    Stack,
    IconButton,
} from "@mui/material";
import ExceptionHandlerController from "../../controller/ErrorLogsController";


const INITIAL_FORM_STATE = {
    subDepartmentName: "",
    subDepartmentCode: "",
    departmentName: "",
    departmentId: "",
    subDepartmentImage: null,
};
const FORM_VALIDATION = Yup.object().shape({
    subDepartmentName: Yup.string()
        .matches(/^[A-Za-z ]*$/, "Sub Department Name is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(3, "Minimum 3 characters required")
        .max(100, "Sub Department Name should not exceed 100 characters")
        .required("Sub Department Name is required"),
    departmentId: Yup.string()
        .matches(/^[0-9a-fA-F]{24}$/, "Invalid Department ID format") // ✅ Only for ObjectId
        .required("Department Name is required"),
    subDepartmentCode: Yup.string()
        .matches(/^[A-Za-z0-9 ]*$/, "sub department Code  is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(2, "Minimum 2 characters required")
        .max(20, "Sub Department Code should not exceed 20 characters")
        .optional(),
    subDepartmentImage: Yup.mixed().optional(),

});


let requestType = "";
const SubDepartment = () => {
    const fileInputRef = useRef(null);
    const departmentController = new DepartmentController();
    const subDepartmentController = new SubDepartmentController();
    const exceptionHandlerController = new ExceptionHandlerController();
    const auth = useAuth();
    const user = auth.decoder(sessionStorage.getItem("user"));
    const { data, token } = user;
    const { userid: userId, tenantid: tenantId } = data.UserInfo;
    const [departmentOptions, setDepartmentOptions] = useState()
    const [subDepartment, setSubDepartment] = useState([])
    const [subDepartmentImage, setSubDepartmentImage] = useState();
    const [popupPreview, setPopUpPreview] = useState({
        subDepartmentImage: false
    });
    const previewPopUpImage = (field, value) =>
        setPopUpPreview((prev) => ({ ...prev, [field]: value }));
    const [loader, setLoader] = useState(true);
    const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
    const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
    const [popup, setPopUp] = useState(false);
    const [allUsers, setAllUsers] = useState([]);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    useEffect(() => {
        getAllSubDepartment();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getAllDepartment = async () => {
        let caughtError;
        try {
            const response = await departmentController.GetDepartmentOptions(token);
            if (response.status === 200) {
                const departmentData = response?.data?.body?.map((item) => ({
                    // ...item,
                    departmentName: item.departmentName,
                    id: item._id,
                }));
                setDepartmentOptions(departmentData);
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllDepartment",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };
    const getAllSubDepartment = async () => {
        let caughtError;
        try {
            const response = await subDepartmentController.GetAllSubDepartment(token);
            if (response.status === 200) {
                const subDepartmentData = response?.data?.body?.map((item) => ({
                    ...item,
                    id: item._id,
                }));
                setSubDepartment(subDepartmentData);
            }
            else if (response?.data?.status === 404) {
                showAlert("error", response?.data?.message);
            } else if (response?.status === 500) {
                showAlert("error", response?.response?.data?.message);
            }
            setLoader(() => false);
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllSubDepartment",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };

    const saveFile = ({ e, setFieldValue, field }) => {
        const file = e.currentTarget.files[0];
        if (!file) return;

        const fileSizeInMB = file.size / (1024 * 1024);
        if (fileSizeInMB > 4) {
            showAlert("error", "Document size should not be more than 4MB");
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            return;
        }

        const extFile = getFileExtension(file.name);
        if (!isValidImageExtension(extFile)) return;

        const reader = new FileReader();
        const WIDTH = 1024;
        const IMAGE_H = 682;
        reader.onload = (event) => {
            const image = new Image();
            image.onload = () => {
                const width = image.naturalWidth;
                const height = image.naturalHeight;
                const aspectRatio = width / height;

                const REQUIRED_ASPECT_RATIO = 1024 / 682;
                const TOLERANCE = 0.3;

                if (Math.abs(aspectRatio - REQUIRED_ASPECT_RATIO) > TOLERANCE) {
                    showAlert(
                        "error",
                        `Invalid aspect ratio. Required: ${WIDTH}x${IMAGE_H} (${REQUIRED_ASPECT_RATIO.toFixed(2)})`
                    );
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                    return;
                }
                // If all checks pass
                setSubDepartmentImage(event.target.result);
                setFieldValue(field, file);
            };

            image.onerror = () => {
                showAlert("error", "Invalid image file.");
            };

            image.src = event.target.result;
        };

        reader.readAsDataURL(file);
    };

    const getFileExtension = (filename) => {
        return filename.split(".").pop().toLowerCase();
    };
    const isValidImageExtension = (ext) => {
        const validExtensions = ["jpg", "jpeg", "png"];
        if (!validExtensions.includes(ext)) {
            showAlert("error", "Only jpeg, png and jpg images are allowed");
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
            return false;
        }
        return true;
    };


    const showAlert = (type, msg) => {
        const notify = { ...alert };
        notify.counter = notify.counter + 1;
        notify.type = type;
        notify.msg = msg;
        setAlert(notify);
    };

    const columns = [
        {
            headerName: "ID",
            field: "id",
            hide: true,
            filterable: false,
            width: 210,
        },
        { headerName: "Sub-department Name", field: "subDepartmentName", width: 210 },
        { headerName: "Sub-department Code", field: "subDepartmentCode", width: 210 },
        {
            field: "action",
            headerName: "Action",
            width: 210,
            sortable: false,
            filterable: false,
            disableExport: true,
            disableClickEventBubbling: true,

            renderCell: (params) => {
                const onClick = (e, type) => {
                    let caughtError;
                    try {
                        setAlert({ counter: 0, type: "", msg: "" });
                        const currentRow = params?.row;
                        if (type === "Edit") {
                            requestType = "Edit";
                            setUpdatedValues(() => currentRow);
                            const currentRowData = currentRow;
                            setUpdatedValues(() => currentRowData);
                            setSubDepartmentImage(currentRow.subDepartmentImage)
                            setDepartmentOptions([{
                                departmentName: currentRow.departmentName,
                                id: currentRow.departmentId
                            }])
                            getAllDepartment()
                            handleData();
                        } else {
                            subDepartmentController
                                .Delete(currentRow.id, token)
                                .then((response) => {
                                    if (response.status === 200) {
                                        getAllSubDepartment()
                                        showAlert("success", "Deleted successfully");
                                        setAllUsers((i) => {
                                            return allUsers.filter(
                                                (item) => item?.id !== currentRow.id
                                            );
                                        });
                                    } else if (response.data.status === 404) {
                                        showAlert("error", response.data.message);
                                    }
                                    else if (response?.status === 500) {
                                        showAlert("error", response?.response?.data?.message);
                                    }
                                })
                                .catch((error) => {
                                    showAlert("error", "Oops something went wrong.");
                                    setTimeout(() => {
                                        setAlert({ counter: 0, type: "", msg: "" });
                                    }, 10000);
                                });
                        }
                    } catch (error) {
                        caughtError = error;
                        let logData = {};
                        logData.message = caughtError?.message;
                        logData.stack = caughtError?.stack;
                        let logError = { logData, module: "Department onClick(Edit) method" };
                        exceptionHandlerController.HandleException(logError);
                    }
                };

                return (
                    <Stack direction="row" spacing={2}>
                        <>
                            <IconButton onClick={(e) => onClick(e, "Edit")}>
                                <EditIcon type="button" color="primary" id="Edit" />
                            </IconButton>
                            <IconButton>
                                <DeleteIcon
                                    type="button"
                                    color="secondary"
                                    id="Delete"
                                    onClick={(e) => onClick(e, "Delete")}
                                />
                            </IconButton>
                        </>
                    </Stack>
                );
            },
        },
    ];

    const AddDepartment = async () => {
        // getRolesDD();
        getAllDepartment()
        requestType = "Add";
        setUpdatedValues(() => INITIAL_FORM_STATE);
        setSubDepartmentImage(null)
        handleData();
    };


    const submitValues = (submitValueData) => {
        let submitData = new FormData();
        // tenantId coming from parent/component
        submitData.append("tenantId", tenantId);
        // Map form fields
        submitData.append("departmentId", submitValueData?.departmentId?.trim() ?? "");
        submitData.append("subDepartmentName", submitValueData?.subDepartmentName?.trim() ?? "");
        submitData.append("subDepartmentCode", submitValueData?.subDepartmentCode?.trim() ?? "");
        submitData.append("subDepartmentImage", submitValueData?.subDepartmentImage ?? "");

        //add for image
        if (requestType === "Edit") {
            // debugger
            submitData.append("id", submitValueData?.id);
            const departmentId = submitValueData?.id;
            // assuming ID comes from backend
            subDepartmentController
                .Update(departmentId, submitData, token)
                .then((response) => {
                    if (response.status === 200) {
                        getAllSubDepartment()
                        showAlert("success", response?.data?.message);
                        handlePopup(false);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                        // getAllCenters();
                    } else {
                        if (response?.data?.status === 204)
                            showAlert("error", response?.data?.message);
                        else if (response?.response?.status === 409)
                            showAlert("error", response?.response?.data?.message);
                        else if (response?.status === 500)
                            showAlert("error", response?.response?.data?.message);

                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    }
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        } else {
            subDepartmentController
                .Create(submitData, token)
                .then((response) => {
                    if (response?.status === 201) {
                        getAllSubDepartment()
                        handlePopup(false);
                        showAlert("success", response?.data?.message);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    } else if (response?.response?.status === 500) {
                        showAlert("error", response?.response?.data?.message);
                    } else if (response?.response?.status === 409) {
                        showAlert("error", response?.response?.data?.message);
                    }
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        }
    };


    const handlePopup = (value) => setPopUp(() => value);
    const handleData = () => setPopUp(() => true);
    if (loader) return <Load />;
    return (
        <>
            <Box
                sx={{
                    "& .formBg": {
                        border: `1px solid ${colors.grey[900]}`,
                        background: `${colors.primary[400]}`,
                    },
                    "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
                    "& .MuiGrid-root.Mui-heading h2": {
                        color: `${colors.primary[200]} !important`,
                    },
                }}
            >
                <Grid container>
                    <Grid className="breadcrumb-section">
                        <Grid className="breadcrumb-container">
                            <Grid className="Mui-li">
                                <nav className="Mui-nav" aria-label="breadcrumb">
                                    <ol className="">
                                        <li className="MuiBreadcrumbs-li">
                                            <h6 className="breadsub">Medical</h6>
                                        </li>
                                        <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                                            /
                                        </li>
                                        <li className="MuiBreadcrumbs-li">
                                            <h6>Sub-department</h6>
                                        </li>
                                    </ol>
                                </nav>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} className="adduser">
                        <Controls.ActionButton onClick={() => AddDepartment()}>
                            <span>Add New</span>
                        </Controls.ActionButton>
                    </Grid>
                    <Grid item xs={12} className="formBg">
                        <Container maxWidth="md" className="formClwidth">
                            <div>
                                <Controls.Grid
                                    columns={columns}
                                    data={subDepartment}
                                    fileName={"Users"}
                                />
                                {popup && (
                                    <Controls.Popup
                                        title="Sub-department Details"
                                        openPopup={popup}
                                        setOpenPopup={handlePopup}
                                    >
                                        <Formik
                                            enableReinitialize
                                            initialValues={{
                                                ...(updatedValues || INITIAL_FORM_STATE),
                                            }}
                                            validationSchema={FORM_VALIDATION}
                                            onSubmit={(values) => submitValues(values)}
                                        >
                                            {({ values, setFieldValue }) => (
                                                <Form>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="subDepartmentName"
                                                                label="Sub-Department Name"
                                                                type="string"
                                                                inputProps={{ maxLength: 100 }}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="subDepartmentCode"
                                                                label="Sub-Department Code"
                                                                type="string"
                                                                inputProps={{ maxLength: 20 }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.AutoComplete
                                                                name="departmentId"
                                                                value={
                                                                    departmentOptions?.find(
                                                                        (opt) => opt.id === values.departmentId) || null
                                                                }
                                                                label={
                                                                    <span>
                                                                        Select Department <span className="asterisk">*</span>
                                                                    </span>
                                                                }
                                                                options={departmentOptions || []}
                                                                getOptionLabel={(option) => option?.departmentName || ""}
                                                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("departmentName", value ? value.departmentName : ""); // ✅ only save string
                                                                    setFieldValue("departmentId", value ? value.id : ""); // ✅ only save string
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <h3 className="upload">
                                                                Sub-department Image <span className="asterisk">*</span>
                                                            </h3>
                                                            <input
                                                                type="file"
                                                                name="subDepartmentImage"
                                                                ref={fileInputRef}
                                                                onChange={(e) => {
                                                                    let field = "subDepartmentImage";
                                                                    saveFile({ e, setFieldValue, field });
                                                                }}
                                                                className="fileupload"
                                                                style={{ width: "70%" }}
                                                            />
                                                            <Grid className="col-lg-2" style={{ float: "right", marginRight: "1px" }}>
                                                                {subDepartmentImage && (
                                                                    <img
                                                                        src={subDepartmentImage}
                                                                        width="55"
                                                                        style={{ cursor: "pointer" }}
                                                                        height="55"
                                                                        onClick={() =>
                                                                            setPopUpPreview((prev) => ({
                                                                                ...prev,
                                                                                subDepartmentImage: true,
                                                                            }))
                                                                        }
                                                                        alt="Logo"
                                                                        className="imgview"
                                                                    />
                                                                )}
                                                                <ImagePreview
                                                                    image={subDepartmentImage}
                                                                    popup={popupPreview?.subDepartmentImage}
                                                                    field={"subDepartmentImage"}
                                                                    handlePopup={previewPopUpImage}
                                                                />
                                                            </Grid>

                                                            <ErrorMessage name="subDepartmentImage">
                                                                {(msg) => (
                                                                    <div style={{ color: "#d32f2f" }}>{msg}</div>
                                                                )}
                                                            </ErrorMessage>
                                                        </Grid>
                                                        <br />
                                                    </Grid>
                                                    <Grid item xs={4} md={2} className="marginAuto">
                                                        <Controls.Button>Submit</Controls.Button>
                                                    </Grid>
                                                </Form>
                                            )}
                                        </Formik>
                                    </Controls.Popup>
                                )}
                            </div>
                        </Container>
                    </Grid>
                    {alert?.counter > 0 && (
                        <CustomizedSnackbars
                            status={alert?.counter}
                            msg={alert?.msg}
                            type={alert?.type}
                        />
                    )}
                </Grid>
            </Box>
        </>
    );
};

export default SubDepartment;
